const CircleSub = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#000",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="4960"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 1024c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512S793.6 1024 512 1024zM512 51.2C256 51.2 51.2 256 51.2 512S256 972.8 512 972.8 972.8 768 972.8 512 768 51.2 512 51.2z"
      fill={color}
      p-id="4961"
    ></path>
    <path
      d="M774.4 537.6 249.6 537.6C236.8 537.6 224 524.8 224 512s12.8-25.6 25.6-25.6l531.2 0c12.8 0 25.6 12.8 25.6 25.6S787.2 537.6 774.4 537.6z"
      fill={color}
      p-id="4962"
    ></path>
  </svg>
);

export default CircleSub;
